<div id="loader">
	<mat-spinner
		*ngIf="isLoading$ | async"
		diameter="30"
		color="primary"
	></mat-spinner>
	<span>{{ statusMessage$ | async }}</span>
</div>
